import { create } from 'zustand';

export type MobileSortOrder = 'newToOld' | 'oldToNew' | 'alphaAZ' | 'alphaZA';

type MobileAssetSortStore = {
  mobileSort: MobileSortOrder | null;
  setMobileSort: (sort: MobileSortOrder | null) => void;
  resetMobileSort: () => void;
};

export const useMobileAssetSortStore = create<MobileAssetSortStore>((set) => ({
  mobileSort: null,
  setMobileSort: (mobileSort) => set({ mobileSort }),
  resetMobileSort: () => set({ mobileSort: null }),
}));
